import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { Employee } from 'src/app/parametrage/core/model/employee/employee';

@Injectable({
    providedIn: 'root'
  })
  export class RepartiteurService{
  
    constructor(private _restClientService : RestClientService) 
    {}
    
    getDetenteur(requestId) 
    {
        return this._restClientService.load<Employee[]>('repartiteur/detenteur/'+requestId);
    }
    
    assigneTaskForCurrentRequest(requestid) 
    {
        return this._restClientService.load<void>('repartiteur/repartir-by-request?requestid='+requestid);
    }
    
}      

    